module.exports = __webpack_public_path__ + "img/Flag_of_the_Cook_Islands.1e152098.svg";